module.exports = __webpack_public_path__ + "static/media/swap-edit.5a6ab714.svg";